var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validation",class:_vm.errorMessageClass,style:(_vm.cssVars)},[_vm._t("default",null,{"doValidation":_vm.doValidation}),_c('div',{staticClass:"feedbackMessage"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }